import type { SVGProps } from "react";

export function IconPurpleBankNote(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M50.9743 14.75H32.75V13.25H53.0257L47.6166 30.25H60.0255L51.2755 57.75H49.7014L57.9742 31.75H47.1393L38.8666 57.75H37.2925L50.9743 14.75Z"
        fill="#2A222A"
      />
      <rect
        x="7"
        y="7"
        width="25"
        height="50"
        fill="#2E2E2E"
        stroke="#2E2E2E"
        strokeWidth="1.5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.7533 6.25H22.2528C22.3838 11.9885 27.0115 16.6162 32.75 16.7472V15.2467C27.84 15.1164 23.8836 11.16 23.7533 6.25ZM32.75 47.2528C27.0115 47.3838 22.3838 52.0115 22.2528 57.75H23.7533C23.8836 52.84 27.84 48.8836 32.75 48.7533V47.2528ZM16.7472 57.75C16.6162 52.0115 11.9885 47.3838 6.25 47.2528V48.7533C11.16 48.8836 15.1164 52.84 15.2467 57.75H16.7472ZM6.25 16.7472C11.9885 16.6162 16.6162 11.9885 16.7472 6.25H15.2467C15.1164 11.16 11.16 15.1164 6.25 15.2467V16.7472ZM9.25 32C9.25 30.7463 10.192 29.4461 12.081 28.4158C13.9416 27.4009 16.5632 26.75 19.5 26.75C22.4368 26.75 25.0584 27.4009 26.919 28.4158C28.808 29.4461 29.75 30.7463 29.75 32C29.75 33.2537 28.808 34.5539 26.919 35.5842C25.0584 36.5991 22.4368 37.25 19.5 37.25C16.5632 37.25 13.9416 36.5991 12.081 35.5842C10.192 34.5539 9.25 33.2537 9.25 32ZM19.5 25.25C16.3617 25.25 13.4833 25.9422 11.3627 27.0989C9.27043 28.2402 7.75 29.94 7.75 32C7.75 34.06 9.27043 35.7598 11.3627 36.9011C13.4833 38.0578 16.3617 38.75 19.5 38.75C22.6383 38.75 25.5167 38.0578 27.6373 36.9011C29.7296 35.7598 31.25 34.06 31.25 32C31.25 29.94 29.7296 28.2402 27.6373 27.0989C25.5167 25.9422 22.6383 25.25 19.5 25.25ZM18.25 18C18.25 17.3096 18.8096 16.75 19.5 16.75C20.1904 16.75 20.75 17.3096 20.75 18C20.75 18.6904 20.1904 19.25 19.5 19.25C18.8096 19.25 18.25 18.6904 18.25 18ZM19.5 15.25C17.9812 15.25 16.75 16.4812 16.75 18C16.75 19.5188 17.9812 20.75 19.5 20.75C21.0188 20.75 22.25 19.5188 22.25 18C22.25 16.4812 21.0188 15.25 19.5 15.25ZM19.5 44.75C18.8096 44.75 18.25 45.3096 18.25 46C18.25 46.6904 18.8096 47.25 19.5 47.25C20.1904 47.25 20.75 46.6904 20.75 46C20.75 45.3096 20.1904 44.75 19.5 44.75ZM16.75 46C16.75 44.4812 17.9812 43.25 19.5 43.25C21.0188 43.25 22.25 44.4812 22.25 46C22.25 47.5188 21.0188 48.75 19.5 48.75C17.9812 48.75 16.75 47.5188 16.75 46Z"
        fill="#1C1719"
      />
    </svg>
  );
}
